import {BACKEND_URL} from "../../../../../configs";
import {globalFetchConfig} from "../../../../../api/apiConfiguration";
import {TranscriptRoutingDecisionUi} from "../../../../../api/generated";

export interface EmailSendingLogUi {
    id: number;
    sentAt: string;
    userId: number;
    lastMessageId: number;
    conversationChannel: string;
    emailType: EmailSendingType;
    templateId: string;
    recipients: string[];
    ccRecipients: Record<string, string>;
    routingDecision?: TranscriptRoutingDecisionUi;
}

export type EmailSendingType =
    | "TRANSCRIPT_DEFAULT"
    | "TRANSCRIPT_ROUTING"
    | "TRANSCRIPT_AFTERSALES"
    | "IMMEDIATE_MESSAGE";

interface EmailSendingLogTableResponse {
    logs: EmailSendingLogUi[];
    totalCount: number;
}

export const getEmailSendingLogs = async (
    botPublicId: string,
    pageNumber: number,
    pageSize: number
): Promise<EmailSendingLogTableResponse> => {
    const searchParams = new URLSearchParams({
        pageNumber: String(pageNumber),
        pageSize: String(pageSize)
    });
    const response = await globalFetchConfig(
        `${BACKEND_URL}/api/private/bot/${encodeURIComponent(botPublicId)}/email-sending-logs?${searchParams}`,
        {method: "GET"}
    );
    if (!response.ok) {
        throw new Error("Failed to load email sending logs");
    }
    return response.json();
};
